import { Component, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Environment } from 'src/environments/environment.model';

import { RecentDeliveriesComponent } from './components/recent-deliveries/recent-deliveries.component';
import { RecentInvoicesComponent } from './components/recent-invoices/recent-invoices.component';
import { TodayComponent } from './components/today/today.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [TodayComponent, RecentDeliveriesComponent, RecentInvoicesComponent],
})
export class DashboardComponent {
  public readonly env = inject<Environment>(EnvironmentInjector);
}
